$(document).ready(function(){

    // Select all CTA buttons
    const ctaButtons = document.querySelectorAll('.ctaBTN');
    // Attach click event to each button
    if(ctaButtons){
        ctaButtons.forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault(); // prevent default jump

                // Get href value (like "#shopTrioSection")
                const targetId = button.getAttribute('href');

                // Make sure it's a valid section id
                if (targetId && targetId.startsWith('#')) {
                const targetSection = document.querySelector(targetId);
                if (targetSection) {
                    // Smooth scroll to that section
                    targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                    });
                }
                }
            }); 
        });
    }
    
    let allAccordionsSection = document.querySelectorAll('.new-accordion-wrap');
    if(allAccordionsSection){
        allAccordionsSection.forEach((accordionWrap) => {
            const accordionHeaders = accordionWrap.querySelectorAll('.accordion-header');

            accordionHeaders.forEach((header) => {
                header.addEventListener('click', () => {
                    const item = header.parentElement;
                    const isActive = item.classList.contains('active');

                    // Close all items inside *this accordion only*
                    accordionWrap.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

                    // If this wasn't active before, open it
                    if (!isActive) {
                        item.classList.add('active');
                    }
                });
            });
        });
    }

    //reviews slider
    $("#reviewsSlider").owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
            <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="20" fill="#BEFF00"/>
            <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
        ],
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.2
            },
            600: {
                items: 2.2
            },
            1000: {
                items: 3
            }
        }
    });

    //reviewsSliderImageCard slider
    $("#reviewsSliderImageCard").owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
            <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="20" fill="#BEFF00"/>
            <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
        ],
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.2
            },
            600: {
                items: 2.2
            },
            1000: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    });

    //image-card-carousel__carousel
    $('.image-card-carousel__carousel').owlCarousel({
        loop: true,
        margin: 12,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        responsive: {
            0: {
                items: 1.1
            },
            500: {
                items: 1.1
            },
            768: {
                items: 3.2
            },
            1024: {
                items: 5
            }
        }
    });

    //resultsSlider
    $("#resultsSlider").owlCarousel({
        items: 1,
        loop: true,
        margin: 12,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
    });

    const $grid = $('.image_card__grid.owl-carousel');
    if ($grid.length && !$grid.hasClass('owl-loaded')) {
        const rawCount = $grid.data('items-count');
        const itemCount = rawCount >= 4 ? 4 : 3;
        $grid.owlCarousel({
            loop: true,
            margin: 24,
            autoplay: false,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            dots: true,
            nav: false,

            responsive: {
                0: {
                items: 1.2,
                margin: 16
                },
                500: {
                items: 2,
                margin: 20
                },
                768: {
                items: 3,
                margin: 24
                },
                1024: {
                items: itemCount
                }
            }
        });
    }
    
       //----collection-tabs-slider starts---//
    /** Slick is disabled at this width and below (mobile only). */
    const COLLECTION_SLIDER_MOBILE_MAX = 768;

    function isMobileCollectionSliderViewport() {
      return window.innerWidth <= COLLECTION_SLIDER_MOBILE_MAX;
    }

    // === Utility: Debounce to limit resize calls ===
    function debounce(func, wait = 150) {
      let timeout;
      return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
      };
  }

  // === Show/hide arrows based on slide position ===
  function updateArrows($slider) {
      const slick = $slider.slick('getSlick');
      const $prevArrow = $slider.siblings('.slick-prev');
      const $nextArrow = $slider.siblings('.slick-next');

      if (slick.currentSlide === 0) {
      $prevArrow.css('display', 'none');
      } else {
      $prevArrow.css('display', 'flex');
      }

      if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
      $nextArrow.css('display', 'none');
      } else {
      $nextArrow.css('display', 'flex');
      }
  }

  // === Slick Slider Initialization ===
  function initSlick($slider) {
      if (isMobileCollectionSliderViewport()) {
      if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
      }
      return;
      }

      if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
          slidesToShow: 4,
          dots: true,
          slidesToScroll: 1,
          arrows: false,
          prevArrow: '<img class="slick-arrow slick-prev" src="https://cdn.shopify.com/s/files/1/0104/8497/3626/files/Button_-_Next_slide.png?v=1760457553" style="display: none;">',
          nextArrow: '<img class="slick-arrow slick-next" src="https://cdn.shopify.com/s/files/1/0104/8497/3626/files/Button_-_Next_slide.png?v=1760457553">',
          infinite: false,
          responsive: [
          {
              breakpoint: 1150,
              settings: { slidesToShow: 3 },
          },
          {
              breakpoint: 990,
              settings: { slidesToShow: 1.2 },
          },
          {
              breakpoint: 550,
              settings: { slidesToShow: 1.8 },
          },
          ],
      });

      // On init, check arrows
      $slider.on('init', function () {
          updateArrows($slider);
      });

      // On slide change, update arrows
      $slider.on('afterChange', function () {
          updateArrows($slider);
      });

      } else {
      $slider.slick('setPosition');
      updateArrows($slider);
      }
  }

  // === Initialize first visible slider ===
  //   const initialSlider = document.querySelector('.collection-slider.active .my-slick-slider');
  //   if (initialSlider) {
  //     initSlick($(initialSlider));
  //   }

  document.querySelectorAll('.collection-slider.active .my-slick-slider').forEach((slider) => {
      initSlick($(slider));
  });

  // === Handle tab switching for multiple sections ===
  document.querySelectorAll('.collection-tabs-section').forEach(section => {
      const tabs = section.querySelectorAll('.collection-tab');
      const sliders = section.querySelectorAll('.collection-slider');

      tabs.forEach(tab => {
          tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-tab');

          // Deactivate only inside this section
          tabs.forEach(t => t.classList.remove('active'));
          sliders.forEach(s => s.classList.remove('active'));

          // Activate selected tab
          tab.classList.add('active');

          // Find matching slider inside this section
          const targetSlider = section.querySelector(`.collection-slider[data-content="${target}"]`);
          if (targetSlider) {
              targetSlider.classList.add('active');

              // Initialize slick only for the active slider
              const slickSlider = targetSlider.querySelector('.my-slick-slider');
              if (slickSlider) {
              initSlick($(slickSlider), section);
              }
          }
          });
      });
  });


  // === Re-initialize Slick on window resize ===
  window.addEventListener('resize', debounce(() => {
      document.querySelectorAll('.collection-slider.active .my-slick-slider').forEach((slider) => {
      initSlick($(slider));
      });
  }, 150));

  const dropdown = document.querySelector(".collection-tabs.mobile");
  const activeItem = dropdown.querySelector(".active-menu-item");
  const menuItems = dropdown.querySelectorAll(".collection-tab");
  const activeTextNode = activeItem.childNodes[0]; // text node before arrow

  // Toggle dropdown
  activeItem.addEventListener("click", function () {
      dropdown.classList.toggle("open");
  });

  // Menu item click
  menuItems.forEach((item) => {
      item.addEventListener("click", function () {
      // Remove active from all
      menuItems.forEach((btn) => btn.classList.remove("active"));

      // Add active to clicked
      this.classList.add("active");

      // Update active text
      activeTextNode.textContent = this.textContent.trim();

      // Close dropdown
      dropdown.classList.remove("open");

      // Optional: redirect to collection
      // const url = this.getAttribute("data-url");
      // if (url) {
      //     window.location.href = url;
      // }
      });
  });

  // Close when clicking outside
  document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) {
      dropdown.classList.remove("open");
      }
  });

  //----collection-tabs-slider ends---//

    



});//doc ready ends